import { axiosInstance } from '@configs/axios/axiosInstance';

import type {
  GetDashboardAlertsRequest,
  GetDashboardAlertsResult,
} from './getDashboardAlerts.types';

export async function getDashboardAlerts({
  organizationId,
}: GetDashboardAlertsRequest): Promise<GetDashboardAlertsResult> {
  const response = await axiosInstance.get<GetDashboardAlertsResult>(
    '/dashboard/alerts',
    {
      headers: {
        'X-Organization-Id': organizationId,
      },
    }
  );
  return response.data;
}
